import "./index.css";

import { type AuthMode, HybridAuthProvider } from "@stardeck/client-auth";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "@/app";

// Read environment variables from Vite
const authConfig = {
  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  authMode: import.meta.env.VITE_AUTH_MODE as AuthMode,
  controlPlaneUrl: import.meta.env.VITE_CONTROL_PLANE_URL,
  baseUrl: import.meta.env.VITE_BASE_URL,
  controlPlaneSignInPath: import.meta.env.VITE_CONTROL_PLANE_SIGN_IN_PATH,
  controlPlaneSignUpPath: import.meta.env.VITE_CONTROL_PLANE_SIGN_UP_PATH,
  afterSignInPath: import.meta.env.VITE_AFTER_SIGN_IN_PATH,
  afterSignUpPath: import.meta.env.VITE_AFTER_SIGN_UP_PATH,
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HybridAuthProvider config={authConfig}>
      <App />
    </HybridAuthProvider>
  </StrictMode>
);
